import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MenuCadastroRequest, MenuCadastroResponse, MenuItems, MenuSistema } from '../models/menuItens.model';
import { Permissao } from '../models/auth.model';
import { ConfigService } from '../core/config/config.service';


@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private readonly configService = inject(ConfigService);
  private get sistemaUrl(): string {
    const baseUrl = this.configService.settings()?.apiUrl;
    return `${baseUrl}/sistema`;
  }

  constructor(private http: HttpClient) { }

  getMenuItems(permissoes: Permissao[]): Observable<MenuItems[]> {
    const menuItems: MenuItems[] = permissoes
      .filter(permissao => permissao.podeVisualizar)
      .map(permissao => ({
        id: permissao.menuItemId,
        parentId: permissao.parentId,
        title: permissao.title,
        slug: permissao.slug,
        level: 0,
        posicao: 0,
        metadata: permissao.metadata
      }));

    return of(menuItems);
  }

  getMenus(): Observable<MenuSistema[]> {
    return this.http.get<MenuSistema[]>(this.sistemaUrl + '/menu');
  }

  getMenu(id: number): Observable<MenuCadastroResponse> {
    return this.http.get<MenuCadastroResponse>(this.sistemaUrl + '/menu/' + id);
  }

  createMenu(menu: MenuCadastroRequest): Observable<MenuCadastroResponse> {
    return this.http.post<MenuCadastroResponse>(this.sistemaUrl + '/menu', menu);
  }

  updateMenu(id: number, menu: MenuCadastroRequest): Observable<MenuCadastroResponse> {
    return this.http.put<MenuCadastroResponse>(this.sistemaUrl + '/menu/' + id, menu);
  }

  deleteMenu(id: number): Observable<void> {
    return this.http.delete<void>(this.sistemaUrl + '/menu/' + id);
  }
}
